export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Tienda online de electrodomésticos para Cuba, productos con garantía, precios competitivos, pago seguro y entrega rápida en La Habana. ¡Encuentra equipos de clima, generadores, ventilación y más!"},{"hid":"keywords","name":"keywords","content":"Tienda online de electrodomésticos para Cuba, Electrodomésticos con garantía, Precios competitivos en electrodomésticos, Pago seguro en electrodomésticos, Entrega rápida en La Habana, Equipos de climatización, Generadores eléctricos, Ventilación para hogar y oficina, Electrodomésticos para el hogar,  Electrodomésticos para oficina, Tienda online en Cuba, Comprar electrodomésticos en Cuba, Ofertas en electrodomésticos, Productos recién llegados, Baterías y back-ups, Paneles solares en Cuba, Sistemas de energía renovable, Móviles y tablets, Tóner para impresoras, Equipamiento de oficina, Aires acondicionados, Ventiladores de techo y pie, Neveras y refrigeradores, Lavadoras automáticas, Lavadoras SEMI-automáticas Televisores y Smart TV, Generadores portátiles, Kit de paneles solares, Productos con garantía en Cuba, Entrega rápida en La Habana, Electrodomésticos para el hogar en Cuba, Equipos de climatización en Cuba, Generadores eléctricos en Cuba, Ventilación para hogar en Cuba, Ofertas en electrodomésticos en Cuba, Productos recién llegados en Cuba, Tienda online de tecnología en Cuba"}],"link":[],"style":[],"script":[],"noscript":[],"title":"Tiodomin Tienda online de electrodomésticos"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true